/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_Two_DetailInputs */

const en_features_gym_two_detail = /** @type {(inputs: Features_Gym_Two_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machines · dumbbells up to 40 kg`)
};

const pl_features_gym_two_detail = /** @type {(inputs: Features_Gym_Two_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maszyny · hantle do 40 kg`)
};

/**
* | output |
* | --- |
* | "Machines · dumbbells up to 40 kg" |
*
* @param {Features_Gym_Two_DetailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_two_detail = /** @type {((inputs?: Features_Gym_Two_DetailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_Two_DetailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_two_detail(inputs)
	return en_features_gym_two_detail(inputs)
});